var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ux-v-center-wrap"},[_c('div',{staticClass:"ux-v-center"},[_c('p',{staticClass:"ux-page-description",domProps:{"innerHTML":_vm._s(_vm.survey.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }